
import {
  FaPlay,
  FaFileAudio,
  FaFilePdf,
  FaFileWord,
  FaFilePowerpoint,
  FaFileAlt,
  FaCode,
} from "react-icons/fa";

const GetLessonType = ({ type,lesson,setPreviewFile }) => {
  return (
    <>
      {type === "video" && <FaPlay onClick={()=>setPreviewFile({type:type,file:lesson.content_file})} className="lesson-icon" style={{cursor:'pointer'}} />}
      {type === "audio" && <FaFileAudio onClick={()=>setPreviewFile({type:type,file:lesson.content_file})} className="lesson-icon" style={{cursor:'pointer'}} />}
      {type === "pdf" && <FaFilePdf onClick={()=>setPreviewFile({type:type,file:lesson.content_file})} className="lesson-icon" style={{cursor:'pointer'}} />}
      {type === "doc" && <FaFileWord onClick={()=>setPreviewFile({type:type,file:lesson.content_file})} className="lesson-icon" style={{cursor:'pointer'}} />}
      {type === "ppt" && <FaFilePowerpoint onClick={()=>setPreviewFile({type:type,file:lesson.content_file})} className="lesson-icon" style={{cursor:'pointer'}} />}
      {type === "txt" && <FaFileAlt onClick={()=>setPreviewFile({type:type,file:lesson.content_file})} className="lesson-icon" style={{cursor:'pointer'}} />}
      {type === "code" && <FaCode onClick={()=>setPreviewFile({type:type,file:lesson.content_file})} className="lesson-icon" style={{cursor:'pointer'}} />}
      {!["video","audio","pdf","doc","ppt","txt","code"].includes(type) && (
        <FaFileAlt className="lesson-icon" />
      )}
    </>
  );
};

export default GetLessonType;
